module.exports = __webpack_public_path__ + "static/img/move1.8569b5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/news2/move1.png
// module id = NDs3
// module chunks = 7